let debounce = (s,n) => {
  // var n = 2;
  if (s == '' || s == void 0) return '暂无';
  n = n > 0 && n <= 20 ? n : 2;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
  var l = s.split(".")[0].split("").reverse(),
  r = s.split(".")[1];
  var t = "";
  for (var i = 0; i < l.length; i ++ ) {
      t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  return t.split("").reverse().join("") + "." + r;
}

let timeFilter = time => {
  if (time == void 0) {
    return '暂无时间'
  } else {
    return time.substring(0,4) + '-' + time.substring(4,6) + '-' + time.substring(6,8) + ' ' + time.substring(8,10) + ':' + time.substring(10,12) + ':' + time.substring(12,14);

  }
}

let dateFilter = time => {
  if (time == void 0) {
    return '暂无日期'
  } else {
    return time.substring(0,4) + '-' + time.substring(4,6) + '-' + time.substring(6,8);

  }
}

export {
  debounce,
  timeFilter,
  dateFilter,
}
